import { compose, withHandlers } from 'recompose';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';

import { getShopId } from '../shops/selectors';
import { getBarberId } from '../barbers/selectors';
import { fetchBarberAvailability, fetchShopBarberAvailability } from '../times/actions';
import { ANY_BARBER } from '../constants';
import { getServiceDuration } from '../services/selectors';
import * as reservationSelectors from '../reservation/selectors';
import withKioskProp from '../hoc/WithKioskProp';

const WithFetchAvailability = compose(
  withKioskProp,
  withRouter,
  connect(
    (state, ownProps) => {
      const serviceId = ownProps.params.serviceId || reservationSelectors.getServiceIds(state);
      const serviceDuration = getServiceDuration(state, serviceId) || reservationSelectors.getServiceDuration(state);
      return {
        anyBarber: (ownProps.params.barberRoute === ANY_BARBER || reservationSelectors.getBookedWithAnyBarber(state)),
        shopId: getShopId(state, ownProps.params.shopRoute) || reservationSelectors.getShopId(state),
        barberId: getBarberId(state, ownProps.params.barberRoute) || reservationSelectors.getBarberId(state),
        serviceDuration,
        serviceId,
      };
    },
    {
      fetchBarberAvailability,
      fetchShopBarberAvailability,
    },
  ),
  withHandlers({
    fetchAvailability: props => (fromDate, endDate, appointmentId) => {
      if (props.anyBarber) {
        return props.fetchShopBarberAvailability(
          props.shopId,
          props.serviceId,
          fromDate,
          endDate,
          appointmentId,
          props.kiosk,
        );
      }
      return props.fetchBarberAvailability(
        props.barberId,
        props.shopId,
        props.serviceDuration,
        fromDate,
        endDate,
        appointmentId,
        props.kiosk,
        props.params.shopRoute,
      );
    },
  }),
);

export default WithFetchAvailability;



// WEBPACK FOOTER //
// ./src/app/hoc/WithFetchAvailability.js